import {
  GENERIC_JOB_SUGGESTIONS,
  ONBOARDING_PRESETS,
  getSmartJobSuggestions,
  type IndustryName,
} from '~/constants/onboardingPresets';
import { buildDraftChecklistDescription } from './services/onboardingService';

/**
 * Find a matching JobSuggestion by job name from presets or smart suggestions.
 * Used to look up frontend-defined checklists for jobs that don't have backend templates.
 * Checks industry presets first, then generic/smart suggestions.
 */
export function findJobSuggestionChecklist(
  jobName: string,
  assetNames: string[],
  assetTypes: string[],
  industry: string | null | undefined
): string | null {
  if (!industry) return null;

  // Check industry-specific presets first
  const industryPreset = ONBOARDING_PRESETS[industry as IndustryName];
  if (industryPreset) {
    const match = industryPreset.jobs.find(
      (j) => j.name.toLowerCase() === jobName.toLowerCase()
    );
    if (match?.checklist && match.checklist.length > 0) {
      return buildDraftChecklistDescription(match.checklist);
    }
  }

  // Check generic and smart job suggestions
  const smartSuggestions = getSmartJobSuggestions(
    assetNames,
    assetTypes,
    industry ?? undefined
  );
  const smartMatch = smartSuggestions.find(
    (j) => j.name.toLowerCase() === jobName.toLowerCase()
  );
  if (smartMatch?.checklist && smartMatch.checklist.length > 0) {
    return buildDraftChecklistDescription(smartMatch.checklist);
  }

  // Check generic suggestions directly
  const genericMatch = GENERIC_JOB_SUGGESTIONS.find(
    (j) => j.name.toLowerCase() === jobName.toLowerCase()
  );
  if (genericMatch?.checklist && genericMatch.checklist.length > 0) {
    return buildDraftChecklistDescription(genericMatch.checklist);
  }

  return null;
}
